
    /**
    * 分销员业绩列表
    **/
      
  import request, {AxiosPromise} from '@utils/request'
  export class IReqid18154 {
  /**
   * 组编号
   */
  bdGroupCode?: string | number;
  index?: string | number;
  size?: string | number;
}
  /**
 * YResult<YListData<DistributionBdDTO>> :YResult
 */
export class IResid18154 {
  code?: {};
  msg?: {};
  success?: {};
  /**
   * YListData
   */
  data?: {
    /**
     * T
     */
    list?: {
      /**
       * 组编号
       */
      bdGroupCode?: {};
      /**
       * BD组名称
       */
      bdGroupName?: {};
      /**
       * bd编号
       */
      bdCode?: {};
      /**
       * bd名称
       */
      bdName?: {};
      /**
       * 拥有主播数
       */
      anchorNum?: {};
      /**
       * 已直播场数
       */
      overLiveNum?: {};
      /**
       * 待直播场数
       */
      waitLiveNum?: {};
      /**
       * 直播转化率
       */
      liveConversionRate?: {};
      /**
       * 复播率
       */
      rebroadcastRate?: {};
      /**
       * 总gvm
       */
      totalGMV?: {};
      /**
       * 周环比增长
       */
      weekRate?: {};
      /**
       * 月环比增长
       */
      monthRate?: {};
      /**
       * 每月GMV ,BdGMVDTO
       */
      bdGMVList?: {
        monthTime?: {};
        /**
         * gvm
         */
        gmv?: {};
      }[];
    }[];
    totalNumber?: {};
    rowId?: {};
  };
  exceptionMsg?: {};
}
  type Serve<T, G> = (data?: T) => AxiosPromise<G>
  const http: Serve<IReqid18154, IResid18154['data'] > = (data?) =>  request({
        method: 'GET',
        url: '/bdGroup/performance/list',
        params: data
      }) 
  export default http